import { render, staticRenderFns } from "./WorkspaceGeneSetNodeInspectorContent.vue?vue&type=template&id=5582cb62&scoped=true"
import script from "./WorkspaceGeneSetNodeInspectorContent.vue?vue&type=script&lang=js"
export * from "./WorkspaceGeneSetNodeInspectorContent.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceGeneSetNodeInspectorContent.vue?vue&type=style&index=0&id=5582cb62&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5582cb62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5582cb62')) {
      api.createRecord('5582cb62', component.options)
    } else {
      api.reload('5582cb62', component.options)
    }
    module.hot.accept("./WorkspaceGeneSetNodeInspectorContent.vue?vue&type=template&id=5582cb62&scoped=true", function () {
      api.rerender('5582cb62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceGeneSetNodeInspectorContent.vue"
export default component.exports